import { IFilingCostDetailsByPID } from "@redux/reducers/filingCostReducer";

export enum ActionType {
  FILING_COST_DETAILS_BY_PID = "FILING_COST_DETAILS_BY_PID",
}

export interface IFilingCostByPid {
  type: ActionType.FILING_COST_DETAILS_BY_PID;
  payload: IFilingCostDetailsByPID[];
}

export type Action = IFilingCostByPid;
